<template>
    <v-card v-bind="$attrs">
        <v-card-subtitle v-if="label">
            {{ label }}
        </v-card-subtitle>

        <v-card
            :loading="uploading"
            color="primary"
            class="d-flex align-center justify-center"
            tile
            flat
            :height="height"
            @click="pick"
        >
            <v-img
                v-if="model"
                :src="model"
                height="100%"
            />

            <v-icon
                v-else
                color="white"
                :size="height * .4"
                class="icon-responsive"
            >
                mdi-upload
            </v-icon>
        </v-card>
        <v-card-actions class="justify-end d-flex flex-wrap pa-4">
            <v-btn
                color="error"
                :disabled="uploading"
                @click="remove"
                outlined
                class="mr-1 my-1"
                v-if="model"
            >
                <v-icon color="error">
                    mdi-trash-can
                </v-icon>
            </v-btn>

            <r-pixibay-picker
                v-model="model"
                class="my-1"
                v-if="!hidePixibay"
            />

            <v-btn
                color="primary"
                :loading="uploading"
                class="my-1"
                @click="pick"
            >
                <v-icon>
                    mdi-upload
                </v-icon>
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        height: {
            type: Number,
            default: 200
        },
        hidePixibay: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            uploading: false,
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
    },
    methods: {
        async pick() {
            const input = document.createElement('input')

            input.type = 'file'
            input.accept = 'image/jpeg, image/png'

            input.onchange = (e) => {
                const file = e.target.files[0]

                this.upload(file)
            }

            input.click()
        },
        async upload(file) {
            this.uploading = true

            const response = await this.$api.uploadImage(file)

            if (response.error) {
                this.uploading = false
                this.$toast('error', response.message)
                return
            }

            this.model = response.message

            setTimeout(() => {
                this.uploading = false
            }, 800)
        },
        remove() {
            this.model = null
        },
    },
}
</script>
